import { Webhook } from 'lucide-react'
import type { NodeProps } from '@xyflow/react'
import { NodeShell } from './nodeTypes'
import type { FlowNode } from './nodeTypes'

export function WebhookNode({ data, selected }: NodeProps<FlowNode>) {
  return (
    <NodeShell
      icon={Webhook}
      label={data.label}
      accentColor="#f59e0b"
      selected={selected}
    />
  )
}
